import React, { cloneElement, isValidElement } from 'react';
import { Tooltip } from '@mantine/core';

export const DENY_REASONS = {
  NO_PERMISSION: 'no_permission',
  LOCKED_PERIOD: 'locked_period'
};

const REASON_MESSAGES = {
  [DENY_REASONS.NO_PERMISSION]: "You don't have permission",
  [DENY_REASONS.LOCKED_PERIOD]: 'You cannot edit previous periods'
};

type DenyReason = (typeof DENY_REASONS)[keyof typeof DENY_REASONS] | string;

interface PermissionGuardProps {
  allowed: boolean;
  reason?: DenyReason;
  children: React.ReactNode;
  disabledProp?: string;
}

export function PermissionGuard({
  allowed,
  reason = DENY_REASONS.NO_PERMISSION,
  children,
  disabledProp = 'disabled'
}: PermissionGuardProps) {
  if (!isValidElement(children)) {
    return children;
  }

  const isDenied = !allowed;
  const resolvedReason = REASON_MESSAGES[reason] ?? reason;
  const isAlreadyDisabled = Boolean(children.props?.[disabledProp]);
  const guardedChild = cloneElement(children, {
    [disabledProp]: isDenied || isAlreadyDisabled
  });

  if (!isDenied) {
    return guardedChild;
  }

  return (
    <Tooltip label={resolvedReason}>
      <span style={{ display: 'inline-flex', pointerEvents: 'all' }}>{guardedChild}</span>
    </Tooltip>
  );
}
